<script lang="ts">
import { xElem } from "@src/common/DOM";
import EditorStore from "@src/model/Editor.Store";
import MainStore from "@src/model/Main.Store";
import { onDestroy, onMount } from "svelte";

import TimelineCaret from "./TimelineCaret.svelte";


let rulerMarkContainer: HTMLDivElement;
let rulerSegsizeIndicatorElem: HTMLSpanElement;
let rulerSizingElement: HTMLInputElement;
let subscribeList: any[] = [];

let markCount = 100;
onMount(() => {
    refreshTimelineRuler();
    EditorStore.getValue().currentTimelineSizingFactor.subscribe((v) => {
        let segspan = Math.pow(600, 1 - v);
        let d = segspan - Math.round(segspan);
        rulerSegsizeIndicatorElem.innerText = `${d < 0.000004? '' : '~'}${Math.round(segspan)}s`;
        
    });
});
onDestroy(() => {
    subscribeList.forEach((v) => v());
});

function refreshTimelineRuler() {
    let pxWidth = ((MainStore.getValue().currentVideoLength.getValue() || 0) / EditorStore.getSegmentLength()) * 100 + 500;
    for (let i = 0; i < Math.max(pxWidth / 10, 500); i++) {
        let type = (
            i % 10 === 0? 2
            : i % 5 === 0? 1
            : 0
        );
        let child = xElem('div');
        child.style.setProperty('margin-left', '9px');
        child.style.setProperty('display', 'inline-block');
        child.style.setProperty('border-left', '1px white solid');
        child.style.setProperty('width', '0');
        child.style.setProperty('height', `${
            [8, 12, 16][type]
        }px`);
        child.style.setProperty('color', 'white');
        child.style.setProperty('font-size', '0.8rem');
        child.style.setProperty('user-select', 'none');
        if (i % 10 === 0) {
            child.innerText = `${(i/10) % 10}`;
            let marknumber = xElem('span');
            marknumber.style.setProperty('float', 'left');
            child.appendChild(marknumber);
        }
        // child.innerText = '00:00';
        rulerMarkContainer.append(child);
    }
}
function handleSizingSliderChange(e) {
    EditorStore.setTimelineSizingFactor(e.target.value);
}
function handleSizingSliderScroll(e) {
    console.log(e);
}
function handleSizingSliderDblClick() {
    let x = prompt('Segsize?');
    rulerSizingElement!.value = `${1 - Math.log(parseFloat(x))/Math.log(600)}`;
    EditorStore.setTimelineSizingFactor(1 - Math.log(parseFloat(x))/Math.log(600));
}
</script>

<div id="ivdemo-timeline-gauge">
    <div id="ivdemo-timeline-gauge-head">
        <input
            id="ivdemo-timeline-gauge-sizing"
            type="range"
            min="0"
            max="1"
            step="any"
            on:input={handleSizingSliderChange}
            on:scroll={handleSizingSliderScroll}
            on:dblclick={handleSizingSliderDblClick}
            bind:this={rulerSizingElement}
        />
    </div>
    <span id="ivdemo-timeline-gauge-ruler-segsize-indicator" bind:this={rulerSegsizeIndicatorElem}></span>
    <div id="ivdemo-timeline-gauge-ruler">
        <div id="ivdemo-timeline-gauge-ruler-mark-container" style="margin-left:-9px" bind:this={rulerMarkContainer}>
            
        </div>
    </div>
</div>

<style>
    #ivdemo-timeline-gauge {
        height: 16px;
        background-color: #333333;
        white-space: nowrap;
    }
    #ivdemo-timeline-gauge-head {
        color: white;
        font-size: 0.8rem;
        width: 160px;
        border-right: 1px #999999 solid;
        text-align: right;
        display: inline-block;
        position: fixed;
        left: 0;
        height: 16px;
        background-color: #333333;
        z-index: 2200;
    }
    #ivdemo-timeline-gauge-sizing {
        margin-left: 0.5rem;
        margin-right: 0.5rem;
        appearance: none;
        -webkit-appearance: none;
        background: transparent;
        border: none;
        margin-bottom: 0;
        height: 16px;
        display: inline-block;
        z-index: 2200;
    }
    #ivdemo-timeline-gauge-sizing::-ms-track {
        width: 100%;
        cursor: pointer;
        background: transparent; 
        border-color: transparent;
        color: transparent;
    }
    #ivdemo-timeline-gauge-sizing:focus {
        outline: none;
    }
    /*  Slider thumb.  */
    #ivdemo-timeline-gauge-sizing::-webkit-slider-thumb {
        -webkit-appearance: none;
        border: 1px white solid;
        width: 12px;
        height: 12px;
        margin-top: -6px;
        background: black;
        cursor: pointer;
    }
    #ivdemo-timeline-gauge-sizing::-moz-range-thumb {
        appearance: none;
        border: 1px white solid;
        width: 12px;
        height: 12px;
        margin-top: -6px;
        background: black;
        cursor: pointer;
        border-radius: 0;
    }
    #ivdemo-timeline-gauge-sizing::-ms-thumb {
        appearance: none;
        border: 1px white solid;
        width: 12px;
        height: 12px;
        margin-top: -6px;
        background: black;
        cursor: pointer;
        border-radius: 0;
    }
    /*  Slider track.  */
    #ivdemo-timeline-gauge-sizing::-webkit-slider-runnable-track {
        width: 100%;
        height: 1px;
        cursor: pointer;
        background: white;
    }
    #ivdemo-timeline-gauge-sizing::-moz-range-track {
        width: 100%;
        height: 1px;
        cursor: pointer;
        background: white;
    }
    #ivdemo-timeline-gauge-sizing::-ms-track {
        width: 100%;
        height: 1px;
        cursor: pointer;
        background: white;
    }


    /*  Ruler.  */
    #ivdemo-timeline-gauge-ruler {
        display: inline-block;
        white-space: nowrap;
        margin-left: 160px;
        background-color: #333333;
        /* width: 3000%; */
    }
    #ivdemo-timeline-gauge-ruler-segsize-indicator {
        position: fixed;
        font-size: 0.8rem;
        color: white;
        z-index: 2200;
    }
</style>

